var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.06989V11.3401C15 12.2031 14.5377 13.0044 13.7903 13.4436L9.21354 16.0864C8.46615 16.5179 7.54155 16.5179 6.78646 16.0864L2.20969 13.4436C1.84121 13.2299 1.53545 12.9231 1.32311 12.5539C1.11077 12.1847 0.999339 11.766 1 11.3401V6.06989C1 5.20693 1.4623 4.40561 2.20969 3.96643L6.78646 1.32361C7.53385 0.89213 8.45845 0.89213 9.21354 1.32361L13.7903 3.96643C14.5377 4.40561 15 5.19923 15 6.06989Z",
    stroke: "#4C3CA6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0844 12.3012C11.0844 10.9143 9.70522 9.78934 8.00241 9.78934C6.29961 9.78934 4.92041 10.9143 4.92041 12.3012M8.00241 7.94014C8.47855 7.94014 8.93518 7.751 9.27186 7.41432C9.60854 7.07764 9.79768 6.62101 9.79768 6.14488C9.79768 5.66874 9.60854 5.21211 9.27186 4.87543C8.93518 4.53875 8.47855 4.34961 8.00241 4.34961C7.52628 4.34961 7.06965 4.53875 6.73297 4.87543C6.39629 5.21211 6.20715 5.66874 6.20715 6.14488C6.20715 6.62101 6.39629 7.07764 6.73297 7.41432C7.06965 7.751 7.52628 7.94014 8.00241 7.94014V7.94014Z",
    stroke: "#4C3CA6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/agent.62e7044faec3f3659bb2d70768ea1091.svg";
export { ForwardRef as ReactComponent };